// import { DefaultGlobalStyles, SiteTemplateFactory} from '../components/global-styling/GlobalStyles'
import { RepositoryFactory } from 'src/api/repositories/RepositoryFactory'
// import { editDOMToSave } from '../lib/Html';
const PagesRepository = RepositoryFactory.get('pages')
const SiteTemplatesRepository = RepositoryFactory.get('siteTemplates')
import Vue from 'vue'
import deepCopy from 'deepcopy'

export default {
    clearCurrentPageData ({commit}, payload) {
        commit('components/clearCurrentPageData');
        commit('clearCurrentPageData');
    },
    setChangesAreSaved ( {commit} , payload) {
        commit('setChangesAreSaved',payload);
    },
    setMagicSliderDisplay ( {commit} , payload) {
        commit('setMagicSliderDisplay' , payload);
    },
    syncNotificationsData ({ dispatch }, data){        
        if (data.courses) {
            dispatch('products/setCourses', data.courses, { root: true } );            
        }

        if (data.userCourses) {
            dispatch('products/setUserDataOnCourses', data.userCourses, { root: true } );
            dispatch('user/setUserDataForBundles', data.userBundleIds, { root: true } );                        
        }
        if(data.hasPendingInvoices){
            dispatch('user/setPendingInvoicesFlag', data.hasPendingInvoices, { root: true } );            
        }

        if(data.trialExpired){
            dispatch('user/setTrialExpiredFlag', data.trialExpired, { root: true } );            
        }

        if(data.me?.subscription?.on_trial){
            dispatch('user/setOnTrial', {
                trialDaysLeft:  data.me.subscription.trial_days_left,
                trialEndFormatted: data.me.subscription.trial_end_formatted,
                trialEnd: data.me.subscription.trial_end
            }, { root: true } );            
        }
       
        if(data.latestCourse){
            dispatch('user/setLatestCourse', data.latestCourse, { root: true } );            
        }

        if (data.data?.unread) {
            dispatch('user/setUnreadInboxMessages', data.data.unread );           
        }
    }
}